import { decodeJwtSessionId } from '@/utils/jwt'

// Dev: proxy do Vue CLI intercepta /wootdash-api → localhost:5080 (evita CORS,
// mesma estratégia já usada pra /chatwoot-api, ver vue.config.js).
// Prod: nginx precisa fazer o mesmo proxy pra onde o WootDash.Api estiver publicado.
export const WOOTDASH_BASE = '/wootdash-api'

// Token renovado (POST /autenticacao/renovar) ou novo login pelo "Continuar logado": vários módulos guardaram o token
// do login (alertas, listas, SignalR) — em vez de reiniciar todos, cada token antigo aponta pro mais novo, pela sessão
// ("sid"). Assim toda requisição sai com o token válido de agora.
const forward = new Map<string, string>()

export function registerRenewedToken(oldToken: string, newToken: string): void {
  const sid = decodeJwtSessionId(oldToken)
  if (sid) forward.set(sid, newToken)
  const newSid = decodeJwtSessionId(newToken)
  if (newSid && newSid !== sid) forward.set(newSid, newToken)
}

/** O token mais novo da mesma sessão (ou de quem a substituiu). */
export function resolveToken(token: string): string {
  let current = token
  for (let hop = 0; hop < 5; hop++) {
    const sid = decodeJwtSessionId(current)
    const next = sid ? forward.get(sid) : undefined
    if (!next || next === current) return current
    current = next
  }
  return current
}

export function wootdashAuthHeaders(token: string): Record<string, string> {
  return { Authorization: `Bearer ${resolveToken(token)}` }
}
